import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'
import useAgency, { useAgencyForm } from '@hooks/useAgency'

const MODAL_KEY = 'ManageAgencyOptionsModal'

type ModalProps = {
  callbacks: {
    closeModal: () => void,
    updateAgency: (payload: any) => void,
  },
  showModal: boolean,
}

const ManageAgencyOptionsModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal, updateAgency } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { agency } = modalPayload

  const {
    callbacks: {
      updateAgency: updateFn,
    },
    updating,
  } = useAgency(agency)

  const agencyFormPayload = useAgencyForm(agency)

  const {
    entityState,
    entityState: { options },
    handlers,
  } = agencyFormPayload

  const {
    campaign_management_platform,
    data_provider_api,
    engage_platform,
    publication_planner,
    realhub_platform,
    system_branding_key,
    xero_integration,
  } = options

  const updateAgencyPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Agency Options Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal} size="small">
      <SidebarModal.Header
        callbacks={callbacks}
        title="Manage"
        titleSecondLine="Agency Options"
      />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Campaign Management Platform">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.campaign_management_platform"
              value={campaign_management_platform}
              {...handlers}
            >
              <option value="">Realhub (Default)</option>
              <option value="campaigntrack">Campaigntrack</option>
              <option value="other">Other</option>
              <option value="none">None</option>
            </select>
          </Form.Field>

          <Form.Field label="Data Provider API" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.data_provider_api"
              value={data_provider_api}
              {...handlers}
            >
              <option value="pricefinder">Pricefinder (Default)</option>
              <option value="core_logic">Core Logic</option>
            </select>
          </Form.Field>

          <Form.Field label="Engage Platform" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.engage_platform"
              value={engage_platform}
              {...handlers}
            >
              <option value="legacy">Legacy (Realhub)</option>
              <option value="standalone">Standalone Engage</option>
            </select>
          </Form.Field>

          <Form.Field label="Publication Planner" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.publication_planner"
              value={publication_planner}
              {...handlers}
            >
              <option value="V1">V1 (Default)</option>
              <option value="V2">V2</option>
            </select>
          </Form.Field>

          <Form.Field label="Realhub Platform" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.realhub_platform"
              value={realhub_platform}
              {...handlers}
            >
              <option value="legacy">Legacy</option>
              <option value="standalone_v1">Standalone</option>
            </select>
          </Form.Field>

          <Form.Field label="System Branding" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.system_branding_key"
              value={system_branding_key}
              {...handlers}
            >
              <option value="">Realhub (Default)</option>
              <option value="campaigntrack">Campaigntrack</option>
              <option value="newsextend">NewsExtend</option>
            </select>
          </Form.Field>

          <Form.Field label="Xero" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select
              name="options.xero_integration"
              value={xero_integration}
              {...handlers}
            >
              <option value="">Please Select...</option>
              <option value="V2">V2 (Default)</option>
            </select>
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updateAgency(updateAgencyPayload)}
          size="large"
        >
          Save Options
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <ManageAgencyOptionsModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
